import type { IMetrics } from '../metrics/types';
import type { ILogger } from '../logging/types';

type TWebVitalReport = {
  name: string;
  value: number;
  id?: string;
  rating?: 'good' | 'needs-improvement' | 'poor';
};

/** Liga `web-vitals` → `metrics.recordWebVital`. CLS/FID/FCP/LCP/TTFB (v2). */
export function installWebVitals(metrics: IMetrics, logger?: ILogger): () => void {
  const onReport = (metric: TWebVitalReport) => {
    metrics.recordWebVital({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      id: metric.id,
    });
  };

  void import('web-vitals')
    .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onReport);
      getFID(onReport);
      getFCP(onReport);
      getLCP(onReport);
      getTTFB(onReport);
    })
    .catch((err: unknown) => {
      logger?.warn('web-vitals unavailable', { error: String(err) });
    });

  // web-vitals v2 get* não desinscreve — cleanup no-op.
  return () => undefined;
}
